require('./js/angular-daterangepicker.js');
module.exports = 'daterangepicker'



//////////////////
// WEBPACK FOOTER
// ./~/angular-daterangepicker/index.js
// module id = 570
// module chunks = 1